export const initialState = {
    loading: true,
    challenge: {},
    onGoingChallenges: [],
    closeChallenges: [],
    tabs: {
        teamMember: false,
        overview: true,
        leaderboard: false,
        activities: false,
    },
    dialogs: {
        signUpDialog: false,
    },
    signUpForm: {
        challengeId: 0,
        teamName: '',
        teamMembers: [
            {
                studentNumber: '',
                isLeader: false
            },
            {
                studentNumber: '',
                isLeader: false
            },
            {
                studentNumber: '',
                isLeader: false
            }
        ]
    },
    alert: {
        severity: 'info', //error,warning,info,success
        message: ''
    },
    signUpLoading: false,
    signUpResult: {
        isError: false,
        message: '',
    },
    reLoadContent: false,
};

export const challengeReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LOADING':
            return { ...state, loading: action.loading };
        case 'SET_TABS':
            return { ...state, tabs: action.tabs };
        case 'SET_DIALOGS':
            return { ...state, dialogs: action.dialogs };
        case 'SET_CHALLENGE':
            return { ...state, challenge: action.challenge };
        case 'SET_ONGOING_CHALLENGES':
            return { ...state, onGoingChallenges: action.onGoingChallenges };
        case 'SET_CLOSE_CHALLENGES':
            return { ...state, closeChallenges: action.closeChallenges };
        case 'SET_SIGNUPFORM':
            return { ...state, signUpForm: action.signUpForm };
        case 'SET_ALERT':
            return { ...state, alert: action.alert };
        case 'SET_SIGNUP_LOADING':
            return { ...state, signUpLoading: action.signUpLoading };
        case 'SET_SIGNUPRESULT':
            return { ...state, signUpResult: action.signUpResult };
        case 'SET_RELOADCONTENT':
            return { ...state, reLoadContent: action.reLoadContent };
        default:
            return state;
    }
}
